import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutEdiApiUsers extends Layout {
    labelHeader: Label;
    sourceEdiApiUser: DataSource;
    tableEdiApiUsers: Table;
}
